import { useTranslation } from 'react-i18next';

export const HeadlessCaptureStandby: React.FunctionComponent = () => {
  const { t } = useTranslation();
  return <>{t('STANDING_BY')}</>;
};
